import { Link } from "react-router-dom";

interface PromoBannerProps {
    label: string;
    imgSrc?: string;
    ctaLabel?: string;
    ctaHref?: string;
}

export const PromoBanner = ({
    label,
    imgSrc,
    ctaLabel,
    ctaHref,
}: PromoBannerProps) => {
    return (
        <section className="relative w-full overflow-hidden rounded-lg bg-secondary/20 min-h-32">
            {imgSrc && (
                <img
                    src={imgSrc}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                />
            )}
            <div className="relative flex flex-col items-start gap-3 p-4">
                <h3 className="text-lg md:text-xl font-bold text-neutral">
                    {label}
                </h3>
                {ctaLabel && ctaHref && (
                    <Link to={ctaHref} className="btn btn-sm btn-warning">
                        {ctaLabel}
                    </Link>
                )}
            </div>
        </section>
    );
};
